import React, { useState, useEffect, useCallback } from 'react';
import { Box } from '@mui/material';
import Header from './Navbar';
import Sidebar from './Sidebar';
import { useAuth } from '../context/authContext';
import { useTheme, useMediaQuery } from '@mui/material';

const DashboardLayout = ({ children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
  const [sidebarOpen, setSidebarOpen] = useState(!isMobile);
  const { userData } = useAuth();

  // Ensure toggleSidebar is always defined
  const toggleSidebar = useCallback(() => {
    console.log("🧩 DashboardLayout: Toggling Sidebar to", !sidebarOpen);
    setSidebarOpen(prev => !prev);
  }, [sidebarOpen]);

  // Sidebar auto-close on mobile only when transitioning screen sizes
  useEffect(() => {
    if (isMobile) {
      setSidebarOpen(false);
    } else {
      setSidebarOpen(true);
    }
  }, [isMobile]);




  const closeSidebar = useCallback(() => {
    if (isMobile) {
      console.log("Closing sidebar on mobile");
      setSidebarOpen(false);
    }
  }, [isMobile]);

  return (
    <Box sx={{
      display: 'flex',
      minHeight: '100vh',
      width: '100%',
      overflowX: 'hidden',
    }}>
      {/* Sidebar */}
      <Sidebar
        open={sidebarOpen}
        user={userData}
        onClose={closeSidebar}
      />

      {/* Main Content Area */}
      <Box
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          minWidth: 0, // Allows the box to shrink below its content's intrinsic width
        }}
      >
        {/* Header - Make sure toggleSidebar is passed */}
        <Header
          user={userData}
          toggleSidebar={toggleSidebar}
          sidebarOpen={sidebarOpen}
        />

        {/* Content */}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: { xs: 2, sm: 2 },
            marginTop: '64px',
            height: 'calc(100vh - 64px)',
            overflowY: 'auto',
            overflowX: 'auto',
            backgroundColor: '#FEFDFF',
          }}
        >
          {children}
        </Box>

      </Box>
    </Box>
  );
};

export default DashboardLayout;